(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  /**
   * Mantém a barra do Essential Countdown Timer fora dos limites do
   * header-group do Dawn, posicionada logo abaixo do cabeçalho. A descoberta é
   * dinâmica porque o aplicativo injeta o contador depois do HTML do tema.
   */
  class HandsCountdownHeader {
    constructor(headerSection) {
      this.headerSection = headerSection;
      this.timerId = 'cm1jkzokj209921923hd1vq4s7';
      this.timerBar = null;
      this.spacer = null;
      this.timerHeight = -1;
      this.timerTop = -1;
      this.searchQueued = false;
      this.layoutQueued = false;

      this.onWindowResize = this.updateLayout.bind(this);
      this.onWindowScroll = this.queueLayout.bind(this);
      this.onMutations = this.queueSearch.bind(this);
      this.resizeObserver = new ResizeObserver(() => this.updateLayout());
      this.mutationObserver = new MutationObserver(this.onMutations);
    }

    connect() {
      this.findAndAttach();
      this.resizeObserver.observe(this.headerSection);

      this.mutationObserver.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style', 'hidden', 'aria-hidden'],
      });

      window.addEventListener('resize', this.onWindowResize, { passive: true });
      window.addEventListener('scroll', this.onWindowScroll, { passive: true });
      window.addEventListener('pageshow', this.onWindowResize);
    }

    disconnect() {
      this.mutationObserver.disconnect();
      this.resizeObserver.disconnect();
      window.removeEventListener('resize', this.onWindowResize);
      window.removeEventListener('scroll', this.onWindowScroll);
      window.removeEventListener('pageshow', this.onWindowResize);
      this.detachTimerBar(false);
    }

    queueSearch() {
      if (this.searchQueued) return;

      this.searchQueued = true;
      requestAnimationFrame(() => {
        this.searchQueued = false;

        if (!this.timerBar || !this.timerBar.isConnected) {
          this.findAndAttach();
        } else {
          this.updateLayout();
        }
      });
    }

    queueLayout() {
      if (this.layoutQueued) return;

      this.layoutQueued = true;
      requestAnimationFrame(() => {
        this.layoutQueued = false;
        this.updateLayout();
      });
    }

    findAndAttach() {
      const timerBar = this.findTimerBar();
      if (!timerBar) {
        if (this.timerBar && !this.timerBar.isConnected) this.detachTimerBar();
        return;
      }
      if (timerBar === this.timerBar) {
        this.updateLayout();
        return;
      }

      if (this.timerBar) {
        this.resizeObserver.unobserve(this.timerBar);
        this.timerBar.removeAttribute('data-hands-countdown-bar');
      }

      if (this.spacer) this.spacer.remove();

      this.timerBar = timerBar;
      this.timerBar.setAttribute('data-hands-countdown-bar', 'true');

      // Retira somente a barra real do contêiner sticky do aplicativo. Isso
      // impede que a posição do timer altere a própria medida do cabeçalho.
      this.headerSection.after(this.timerBar);

      this.spacer = document.createElement('div');
      this.spacer.setAttribute('data-hands-countdown-spacer', 'true');
      this.spacer.setAttribute('aria-hidden', 'true');
      this.timerBar.after(this.spacer);

      this.resizeObserver.observe(this.timerBar);
      this.updateLayout();
    }

    detachTimerBar(notify = true) {
      if (this.timerBar) {
        this.resizeObserver.unobserve(this.timerBar);
        this.timerBar.removeAttribute('data-hands-countdown-bar');
      }

      if (this.spacer) this.spacer.remove();

      this.timerBar = null;
      this.spacer = null;
      this.timerHeight = 0;
      this.timerTop = 0;
      document.documentElement.style.setProperty('--hands-countdown-height', '0px');
      document.documentElement.style.setProperty('--hands-countdown-top', '0px');

      if (notify) {
        document.dispatchEvent(new CustomEvent('hands:countdown:resize', { detail: { height: 0 } }));
      }
    }

    findTimerBar() {
      const exactSelector = [
        `[id*="${this.timerId}" i]`,
        `[class*="${this.timerId}" i]`,
        `[data-id*="${this.timerId}" i]`,
        `[data-timer-id*="${this.timerId}" i]`,
        `[data-countdown-id*="${this.timerId}" i]`,
      ].join(',');

      const appSelector = [
        '[class*="essential-countdown" i]',
        '[id*="essential-countdown" i]',
        '[class*="countdown-timer" i]',
        '[id*="countdown-timer" i]',
        '[data-app*="countdown" i]',
        'iframe[src*="essential" i]',
      ].join(',');

      const exactCandidates = Array.from(document.querySelectorAll(exactSelector));
      const genericCandidates = Array.from(document.querySelectorAll(appSelector));
      const candidates = [...new Set([...exactCandidates, ...genericCandidates])];
      const headerContainer = this.headerSection.parentElement;

      if (!exactCandidates.length && headerContainer) {
        headerContainer.querySelectorAll('div, section, aside').forEach((element) => {
          const text = element.textContent || '';
          if (/\d{1,2}\s*:\s*\d{2}/.test(text)) candidates.push(element);
        });
      }

      const uniqueRoots = [...new Set(candidates.map((candidate) => this.getTimerRoot(candidate)).filter(Boolean))];
      let bestMatch = null;
      let bestScore = -1;

      uniqueRoots.forEach((candidate) => {
        const score = this.scoreCandidate(candidate);
        if (score > bestScore) {
          bestScore = score;
          bestMatch = candidate;
        }
      });

      return bestScore >= 80 ? bestMatch : null;
    }

    getTimerRoot(element) {
      if (!(element instanceof HTMLElement)) return null;
      if (this.containsHeader(element)) return null;

      let root = element;
      let parent = element.parentElement;

      while (parent && parent !== document.body) {
        // Nunca seleciona o header-group, a section-header ou qualquer
        // ancestral que também envolva o cabeçalho da loja.
        if (parent === this.headerSection || this.containsHeader(parent)) break;

        const rect = parent.getBoundingClientRect();
        const identity = `${parent.id} ${parent.className}`.toLowerCase();
        const position = getComputedStyle(parent).position;
        const isTimerWrapper = identity.includes('essential') || identity.includes('countdown');
        const isCompactSticky = ['fixed', 'sticky'].includes(position) && rect.height > 0 && rect.height <= 220;

        if ((isTimerWrapper || isCompactSticky) && rect.height <= 220) {
          root = parent;
          parent = parent.parentElement;
          continue;
        }

        break;
      }

      return root;
    }

    containsHeader(element) {
      return element === this.headerSection
        || element.contains(this.headerSection)
        || Boolean(element.querySelector('sticky-header, .header-wrapper, header.header'));
    }

    scoreCandidate(element) {
      if (this.containsHeader(element)) return -1;

      const rect = element.getBoundingClientRect();
      if (rect.height < 10 || rect.height > 220 || rect.width < window.innerWidth * 0.55) return -1;

      const identity = `${element.id} ${element.className}`.toLowerCase();
      const text = element.textContent || '';
      const position = getComputedStyle(element).position;
      let score = 0;

      if (identity.includes('essential')) score += 70;
      if (identity.includes('countdown')) score += 55;
      if (identity.includes(this.timerId.toLowerCase())) score += 100;
      if (Array.from(element.attributes).some((attribute) => attribute.value.toLowerCase().includes(this.timerId.toLowerCase()))) score += 100;
      if (position === 'sticky' || position === 'fixed') score += 70;
      if (element.closest('.shopify-section-group-header-group')) score += 45;
      if (/\d{1,2}\s*:\s*\d{2}/.test(text)) score += 30;
      if (rect.width >= window.innerWidth * 0.9) score += 25;
      if (rect.top < 180) score += 15;

      return score;
    }

    updateLayout() {
      if (!this.timerBar || !this.timerBar.isConnected) return;

      const styles = getComputedStyle(this.timerBar);
      const isHidden = styles.display === 'none' || styles.visibility === 'hidden' || this.timerBar.hidden;
      const height = isHidden ? 0 : Math.ceil(this.timerBar.getBoundingClientRect().height);
      const headerBottom = Math.max(0, Math.ceil(this.headerSection.getBoundingClientRect().bottom));

      if (headerBottom !== this.timerTop) {
        this.timerTop = headerBottom;
        document.documentElement.style.setProperty('--hands-countdown-top', `${headerBottom}px`);
      }

      if (height === this.timerHeight) return;
      this.timerHeight = height;

      document.documentElement.style.setProperty('--hands-countdown-height', `${height}px`);
      document.dispatchEvent(new CustomEvent('hands:countdown:resize', { detail: { height } }));
    }
  }

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.countdownHeader = new HandsCountdownHeader(this.header);
      this.countdownHeader.connect();
      this.onCountdownResize = () => {
        this.setHeaderHeight();
        this.createObserver();
      };
      document.addEventListener('hands:countdown:resize', this.onCountdownResize);

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      document.removeEventListener('hands:countdown:resize', this.onCountdownResize);
      if (this.headerObserver) this.headerObserver.disconnect();
      if (this.countdownHeader) this.countdownHeader.disconnect();
    }

    createObserver() {
      if (this.headerObserver) this.headerObserver.disconnect();

      this.headerObserver = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      this.headerObserver.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
